/**
 * DASHBOARD-RPS-TEAMS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-rps-teams.widget.tsx : titre + dropdown de filtre, puis
 * une rangée par population (libellé + barre empilée), avec un reflet qui balaie.
 * Le graphique réel est en Plotly (non animable via nos hooks) — skeleton uniquement.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

//Largeurs (% de la zone de tracé) qui rappellent des populations de tailles variées
const BAR_WIDTHS = [55, 90, 40, 35, 45, 60, 25]

export default function DashboardRpsTeamsSkeletonWidget() {
  return (
    <div className="rel" style={{ overflow: "hidden" }}>
      <div className="flex items-center">
        <Skeleton width={160} height={22} />
        <div className="flex1" />
        <Skeleton width={140} height={36} borderRadius={8} />
      </div>

      <div style={{ marginTop: 24 }}>
        {BAR_WIDTHS.map((width, i) => (
          <div key={i} className="flex items-center" style={{ marginBottom: 16, gap: 16 }}>
            <Skeleton width={130} height={13} />
            <div style={{ flex: 1 }}>
              <Skeleton width={`${width}%`} height={20} borderRadius={4} />
            </div>
          </div>
        ))}
      </div>

      <SkeletonShine />
    </div>
  )
}
